export const contentElementHelpers = async (err) => {
  if (err) {
    console.error(err);
  }

  /*
   * Click on entire element for:
   * threecol teasers
   * twocol teasers
   * vertical accordion elements
   */
  const clickableContainers = document.querySelectorAll(
    '.main .threecol .wp-block-columns .wp-block-column, .images-masonry .wp-block-cover, .gm-vertical-accordion .wp-block-accordion-item',
  );

  for (var i = 0; i < clickableContainers.length; i++) {
    let teaserItem = clickableContainers[i],
      linkTag = '';

    if (teaserItem.querySelector('.wp-block-button__link')) {
      linkTag = teaserItem.querySelector('.wp-block-button__link');
    }

    if (
      teaserItem.querySelector(
        '.wp-block-cover__inner-container .wp-block-paragraph a',
      )
    ) {
      linkTag = teaserItem.querySelector(
        '.wp-block-cover__inner-container .wp-block-paragraph a',
      );
    }

    if (teaserItem.querySelector('.wp-block-accordion-heading__toggle')) {
      // vertical accordion teaser: click on teaser item to open accordion if not already open

      let panelTag = teaserItem.querySelector(
        '.wp-block-accordion-heading__toggle',
      );

      // Prüfen, ob das Element existiert und nicht bereits geöffnet ist
      if (panelTag && !teaserItem.classList.contains('is-open')) {
        // Klick auf das Element, um es zu öffnen

        teaserItem.addEventListener('click', (event) => {
          panelTag.click();
          event.preventDefault();
        });

        panelTag.addEventListener('click', (event) => {
          panelTag.click();
          event.preventDefault();
        });
      }
    }

    if (linkTag) {
      teaserItem.addEventListener('click', (event) => {
        let url = linkTag.getAttribute('href');
        if (url) {
          window.open(url, '_self');
        }

        event.preventDefault();
      });
    }
  }

  /*
   * Click on entire element for:
   * query loop posttype teasers
   */
  const posttypeTeaserItems = document.querySelectorAll(
    '.wp-block-query .wp-block-post',
  );

  for (i = 0; i < posttypeTeaserItems.length; i++) {
    let teaserItem = posttypeTeaserItems[i],
      linkTag = '';
    teaserItem.style.cursor = 'pointer';
    if (teaserItem.querySelector('.wp-block-post-title a')) {
      linkTag = teaserItem.querySelector('.wp-block-post-title a');
    }

    if (teaserItem.querySelector('.wp-block-read-more')) {
      linkTag = teaserItem.querySelector('.wp-block-read-more');
    }

    if (linkTag) {
      teaserItem.addEventListener('click', (event) => {
        let url = linkTag.getAttribute('href');
        if (url) {
          window.open(url, '_self');
        }

        event.preventDefault();
      });
    }
  }

  /*
   * Disable past dates for datepicker in booking form
   */
  const datepickers = document.querySelectorAll(
    '.wpcf7-form .form-input-field',
  );
  if (datepickers) {
    datepickers.forEach((datepicker) => {
      const input = datepicker.querySelector('input[type="date"]');
      if (input) {
        const today = new Date().toISOString().split('T')[0];
        input.setAttribute('min', today);
      }
    });
  }
  /*
   * format date inside teaser flag
   */
  /*   const dateFlag = document.querySelectorAll(
    '.custom-posttype-grid-acf-fields span',
  );
  if (dateFlag) {
    dateFlag.forEach((flag) => {
      flag.textContent = flag.textContent.substring(0, 6);
    });
  } */

  /*
   * Scroll vertical accordion item to the left when clicked
   */
  const verticalAccordionItems = document.querySelectorAll(
    '.gm-vertical-accordion .wp-block-accordion-item',
  );

  verticalAccordionItems.forEach((item) => {
    item.addEventListener('click', () => {
      setTimeout(() => {
        item.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'start',
        });
      }, 100);
    });
  });
};

import.meta.webpackHot?.accept(contentElementHelpers);
